import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { connect } from 'react-redux';

import { handleSearch, changeNumberDispatch, makeStatusActive, makeStatusInActive } from '../actions';
import SearchResults from './search-results';

global.searchChangeNumber = 0;

class HeaderSearch extends Component {
	constructor() {
		super();

		this.handleClick = this.handleClick.bind( this );
		this.handleScroll = this.handleScroll.bind( this );
	}

	componentWillMount() {
		// add event listener for clicks
		document.addEventListener( 'click', this.handleClick, false );
		window.addEventListener( 'scroll', this.handleScroll, false );
	}

	componentWillUnmount() {
		// make sure you remove the listener when the component is destroyed
		document.removeEventListener( 'click', this.handleClick, false );
		window.removeEventListener( 'scroll', this.handleScroll, false );
	}

	componentDidMount() {
		window.addEventListener( 'scroll', this.handleScroll, false );
	}

	handleScroll() {
		//close search filters on scroll always
		this.props.makeStatusInActive();
	}

	handleSubmit( event ) {
		event.preventDefault();
		window.location = `/search/${this.props.searchTerm}`;
	}

	handleCloseClick() {
		this.props.makeStatusInActive();
	}

	handleClick( event ) {
		if ( this.props.isActive ) {
			if ( !ReactDOM.findDOMNode( this )
			              .contains( event.target ) ) {
				this.props.makeStatusInActive();
			}
		}
	}

	doSearch( event ) {
		global.searchChangeNumber = global.searchChangeNumber + 1;
		if ( event.target.value.charAt(0) === '.' ) {
			event.target.value = event.target.value.substring(1);
		}
		this.props.handleSearch( event.target.value );
		this.props.changeNumberDispatch( global.searchChangeNumber );
	}

	doChatbotPrompt() {
		window.location.href = `/search-bot?prompt=${this.props.searchTerm}`;
	}

	renderChatBotIcon() {
		return <svg width="20" height="20" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path fill-rule="evenodd" clip-rule="evenodd" d="M107.5 41.7687C107.5 37.6266 104.143 34.2687 100 34.2687H46.154C32.9111 34.2687 21.2927 38.7157 12.966 47.0423C4.63942 55.3689 0.192409 66.9874 0.192409 80.2302V126.384C0.192409 139.627 4.63942 151.245 12.966 159.572C19.6799 166.286 28.5339 170.477 38.654 171.849V181.23C38.654 193.413 52.2087 200.541 62.2372 193.855L94.5744 172.346H123.077C136.32 172.346 147.938 167.899 156.265 159.572C164.592 151.245 169.039 139.627 169.039 126.384V117.426C169.039 113.284 165.681 109.926 161.539 109.926C157.396 109.926 154.039 113.284 154.039 117.426V126.384C154.039 136.218 150.793 143.83 145.658 148.965C140.523 154.1 132.911 157.346 123.077 157.346H92.3078C90.8298 157.346 89.3847 157.782 88.154 158.601L53.9231 181.37C53.8964 181.388 53.8712 181.402 53.8608 181.407L53.8463 181.414C53.8411 181.414 53.7984 181.413 53.7383 181.38C53.6919 181.356 53.6691 181.331 53.6619 181.322L53.6583 181.304C53.6564 181.291 53.654 181.267 53.654 181.23V164.846C53.654 160.703 50.2961 157.346 46.154 157.346C36.3199 157.346 28.7076 154.1 23.5726 148.965C18.4377 143.83 15.1924 136.218 15.1924 126.384V80.2302C15.1924 70.3961 18.4377 62.7839 23.5726 57.6489C28.7076 52.514 36.3199 49.2687 46.154 49.2687H100C104.143 49.2687 107.5 45.9108 107.5 41.7687Z" fill="#323232"/>
			<path d="M125 40C123.178 40 121.548 41.1346 120.916 42.8435L117.921 50.9381C113.855 61.9257 112.202 66.1226 109.163 69.1629C106.123 72.2026 101.926 73.8545 90.9381 77.9208L82.8435 80.9157C81.1346 81.5481 80 83.1779 80 85C80 86.8221 81.1346 88.4519 82.8435 89.0843L90.9381 92.0792C101.926 96.1455 106.123 97.7974 109.163 100.837C112.202 103.877 113.855 108.074 117.921 119.062L120.916 127.157C121.548 128.865 123.178 130 125 130C126.822 130 128.452 128.865 129.084 127.157L132.079 119.062C136.145 108.074 137.797 103.877 140.837 100.837C143.877 97.7974 148.074 96.1455 159.062 92.0792L167.157 89.0843C168.865 88.4519 170 86.8221 170 85C170 83.1779 168.865 81.5481 167.157 80.9157L159.062 77.9208C148.074 73.8545 143.877 72.2026 140.837 69.1629C137.797 66.1226 136.145 61.9257 132.079 50.9381L129.084 42.8435C128.452 41.1346 126.822 40 125 40Z" fill="#323232"/>
			<path d="M173.125 8.125C171.033 8.125 169.162 9.42767 168.436 11.3898L166.962 15.3728C164.87 21.0247 164.262 22.3615 163.312 23.3117C162.362 24.2619 161.025 24.8705 155.373 26.9619L151.39 28.4357C149.428 29.1618 148.125 31.0328 148.125 33.125C148.125 35.2172 149.428 37.0882 151.39 37.8143L155.373 39.2881C161.025 41.3795 162.362 41.9881 163.312 42.9383C164.262 43.8885 164.87 45.2253 166.962 50.8772L168.436 54.8602C169.162 56.8223 171.033 58.125 173.125 58.125C175.217 58.125 177.088 56.8223 177.814 54.8602L179.288 50.8772C181.38 45.2253 181.988 43.8885 182.938 42.9383C183.888 41.9881 185.226 41.3795 190.877 39.2881L194.86 37.8143C196.822 37.0882 198.125 35.2172 198.125 33.125C198.125 31.0328 196.822 29.1618 194.86 28.4357L190.877 26.9619C185.226 24.8705 183.888 24.2619 182.938 23.3117C181.988 22.3615 181.38 21.0247 179.288 15.3728L177.814 11.3898C177.088 9.42767 175.217 8.125 173.125 8.125Z" fill="#323232"/>
		</svg>
	}

	render() {
		return (<div>
				<form id="page-search" role="search"
				      onSubmit={ this.handleSubmit.bind( this ) }
				      aria-label="Global Search Form" method="get"
				      className="search-form">
					<label className="glyphicon glyphicon-search"
					       htmlFor="global-isda-search"><span
						className="sr-only">Search ISDA</span></label>
					<input id="global-isda-search" type="search" name="s"
					       onChange={ this.doSearch.bind( this ) }
					       onFocus={ this.props.makeStatusActive }
					       className="form-control"
					       required={true}
					       placeholder="What can we help you find today?"
					       value={ this.props.searchTerm } autoComplete="off"/>
					<div className="search-buttons-divider"></div>
					<div className="d-flex">
						<button className="search-global" type="submit">
							<i className="glyphicon glyphicon-search"></i>
						</button>
						<button type="button" className="search-chatbot"
						        onClick={ this.doChatbotPrompt.bind( this ) }>
							{ this.renderChatBotIcon() }
						</button>
					</div>

				</form>
				{/*<div id="page-search-filters" className={ (this.props.isActive*/ }
				{/*                                          ) ? 'active' : '' }>*/ }
				{/*	<p className="help-block search-help">Press the Enter key to view the full results of your search.</p>*/ }
				{/*	<SearchResults />*/ }
				{/*	<button type="button" id="btn-exit-search" onClick={ this.handleCloseClick.bind( this ) }*/ }
				{/*	        className="page-filter-ctas pull-right"*/ }
				{/*	        name="Exit page search">*/ }
				{/*		<span className="glyphicon glyphicon-remove" aria-hidden="true"></span>*/ }
				{/*		Close*/ }
				{/*	</button>*/ }
				{/*</div>*/ }
			</div>
		);
	}
}

function mapStateToProps( { searchTerm, changeNumber, isActive } ) {
	return { searchTerm, changeNumber, isActive };
}

export default connect( mapStateToProps, {
	makeStatusInActive, makeStatusActive, handleSearch, changeNumberDispatch
} )( HeaderSearch );